import _anObject from "../internals/an-object";
import _isObject from "../internals/is-object";
import _newPromiseCapability from "../internals/new-promise-capability";
var exports = {};
var anObject = _anObject;
var isObject = _isObject;
var newPromiseCapability = _newPromiseCapability;
exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};
export default exports;